import { FormattedMessage } from 'react-intl';

export const NoValue = () => <>-</>;
export const ToBeDefined = () => <FormattedMessage id="labels.tbd" />;
